// extracted by mini-css-extract-plugin
export default {"labelText":"AddPromotionDetail_labelText__vM5um","btnAdd":"AddPromotionDetail_btnAdd__0aNif"};